import { useState } from 'react';

const DIAS = ['Lunes','Martes','Miércoles','Jueves','Viernes','Sábado','Domingo'];
const HORARIOS = [
  { id: 'manana', label: 'Mañana',  desc: '07:00 – 12:00' },
  { id: 'tarde',  label: 'Tarde',   desc: '12:00 – 18:00' },
  { id: 'noche',  label: 'Noche',   desc: '18:00 – 23:00' },
];

export default function StepDisponibilidadArbitro({ datos, onNext, onBack, cargando }) {
  const [dias,     setDias]     = useState(datos.dias     || []);
  const [horarios, setHorarios] = useState(datos.horarios || []);
  const [error,    setError]    = useState('');

  const toggleDia = (dia) => {
    setDias(prev =>
      prev.includes(dia) ? prev.filter(d => d !== dia) : [...prev, dia]
    );
    setError('');
  };

  const toggleHorario = (id) => {
    setHorarios(prev =>
      prev.includes(id) ? prev.filter(h => h !== id) : [...prev, id]
    );
    setError('');
  };

  const handleNext = () => {
    if (dias.length === 0)     { setError('Selecciona al menos un día');     return; }
    if (horarios.length === 0) { setError('Selecciona al menos un horario'); return; }
    onNext({ dias, horarios });
  };

  return (
    <div style={styles.wrap}>
      <h2 style={styles.titulo}>Tu disponibilidad</h2>
      <p style={styles.sub}>
        Los equipos solo te verán disponible en los días
        y horarios que selecciones aquí.
      </p>

      {/* Días */}
      <div style={styles.campo}>
        <label style={styles.label}>Días disponibles</label>
        <div style={styles.diasGrid}>
          {DIAS.map(dia => {
            const activo = dias.includes(dia);
            return (
              <div
                key={dia}
                onClick={() => toggleDia(dia)}
                style={{
                  ...styles.diaChip,
                  background: activo ? '#1A6BFF' : '#F4F6FA',
                  color:      activo ? 'white'   : '#4A5568',
                  border:     `1.5px solid ${activo ? '#1A6BFF' : '#E8ECF4'}`,
                }}
              >
                {dia.slice(0, 3)}
              </div>
            );
          })}
        </div>
      </div>

      {/* Horarios */}
      <div style={styles.campo}>
        <label style={styles.label}>Horarios disponibles</label>
        <div style={styles.horariosGrid}>
          {HORARIOS.map(({ id, label, desc }) => {
            const activo = horarios.includes(id);
            return (
              <div
                key={id}
                onClick={() => toggleHorario(id)}
                style={{
                  ...styles.horarioCard,
                  border:     `2px solid ${activo ? '#1A6BFF' : '#E8ECF4'}`,
                  background: activo ? '#EFF5FF' : 'white',
                }}
              >
                <div style={{
                  ...styles.horarioLabel,
                  color: activo ? '#1A6BFF' : '#141922',
                }}>
                  {label}
                </div>
                <div style={styles.horarioDesc}>{desc}</div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Preview */}
      {dias.length > 0 && horarios.length > 0 && (
        <div style={styles.preview}>
          <div style={styles.previewTitle}>Estarás disponible</div>
          <div style={styles.previewDias}>{dias.join(' · ')}</div>
          <div style={styles.previewHorarios}>
            {horarios.map(h =>
              HORARIOS.find(x => x.id === h)?.desc
            ).join(' · ')}
          </div>
        </div>
      )}

      {error && <p style={styles.error}>{error}</p>}

      <div style={styles.botones}>
        <button style={styles.btnBack} onClick={onBack}>← Atrás</button>
        <button
          style={{ ...styles.btnFinalizar, opacity: cargando ? 0.7 : 1 }}
          onClick={handleNext}
          disabled={cargando}
        >
          {cargando ? 'Registrando...' : '¡Registrarme como árbitro! ⚡'}
        </button>
      </div>
    </div>
  );
}

const styles = {
  wrap: { width: '100%' },
  titulo: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 26, fontWeight: 800, color: '#141922', marginBottom: 4,
  },
  sub: {
    fontSize: 13, color: '#6B7280',
    fontFamily: "'Barlow', sans-serif", marginBottom: 24, lineHeight: 1.5,
  },
  campo: { marginBottom: 20 },
  label: {
    display: 'block', fontSize: 11, fontWeight: 700,
    color: '#6B7280', textTransform: 'uppercase',
    letterSpacing: '0.05em', marginBottom: 8,
    fontFamily: "'Barlow', sans-serif",
  },
  diasGrid: { display: 'flex', gap: 8, flexWrap: 'wrap' },
  diaChip: {
    padding: '8px 14px', borderRadius: 20,
    fontSize: 12, fontWeight: 600,
    cursor: 'pointer', transition: 'all 0.12s',
    fontFamily: "'Barlow', sans-serif",
  },
  horariosGrid: {
    display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10,
  },
  horarioCard: {
    borderRadius: 12, padding: '14px',
    cursor: 'pointer', transition: 'all 0.12s',
    textAlign: 'center',
  },
  horarioLabel: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 18, fontWeight: 800, marginBottom: 4,
  },
  horarioDesc: {
    fontSize: 12, color: '#9BA5B7',
    fontFamily: "'Barlow', sans-serif",
  },
  preview: {
    background: '#F0FDF4', border: '1.5px solid #86EFAC',
    borderRadius: 12, padding: '14px 18px',
    marginBottom: 20, textAlign: 'center',
  },
  previewTitle: {
    fontSize: 11, fontWeight: 700, color: '#16A34A',
    textTransform: 'uppercase', letterSpacing: '0.05em',
    fontFamily: "'Barlow', sans-serif", marginBottom: 6,
  },
  previewDias: {
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 16, fontWeight: 700, color: '#16A34A', marginBottom: 4,
  },
  previewHorarios: {
    fontSize: 13, color: '#16A34A',
    fontFamily: "'Barlow', sans-serif",
  },
  error: {
    color: '#EF4444', fontSize: 12,
    fontFamily: "'Barlow', sans-serif", marginBottom: 12,
  },
  botones: { display: 'grid', gridTemplateColumns: '1fr 2fr', gap: 10 },
  btnBack: {
    padding: '13px', background: 'white',
    border: '1.5px solid #E8ECF4', borderRadius: 12,
    fontSize: 14, fontWeight: 700, color: '#6B7280',
    cursor: 'pointer',
    fontFamily: "'Barlow Condensed', sans-serif",
  },
  btnFinalizar: {
    padding: '13px', background: '#FF6B1A', border: 'none',
    borderRadius: 12,
    fontFamily: "'Barlow Condensed', sans-serif",
    fontSize: 16, fontWeight: 800, color: 'white', cursor: 'pointer',
  },
};